/* @ts-nocheck */
/* eslint-disable */
/* @noformat */
/* @formatter:off */
/**
* Generated by ng-openapi
* Generated Angular service for HSubscriptionController controller
* Do not edit this file manually
*/
import { HttpClient, HttpContext, HttpContextToken, HttpEvent, HttpHeaders, HttpParams, HttpResponse } from "@angular/common/http";
import { inject, Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { BASE_PATH_VERSUSCLIENT, CLIENT_CONTEXT_TOKEN_VERSUSCLIENT } from "../tokens";
import { HttpParamsBuilder } from "../utils/http-params-builder";
import { HousingSubscription, RequestOptions, Pageable, PagedModelHousingSubscription, HCustomerSubscriptionDto } from "../models";

@Injectable({ providedIn: "root" })
export class HSubscriptionControllerService {
    private readonly httpClient: HttpClient = inject(HttpClient);
    private readonly basePath: string = inject(BASE_PATH_VERSUSCLIENT);
    private readonly clientContextToken: HttpContextToken<string> = CLIENT_CONTEXT_TOKEN_VERSUSCLIENT;

    private createContextWithClientId(existingContext?: HttpContext): HttpContext {
        const context = existingContext || new HttpContext();
        return context.set(this.clientContextToken, 'VersusClient');
    }

    subscribe1(housingSubscription: HousingSubscription, observe?: 'body', options?: RequestOptions<'json'>): Observable<HousingSubscription>;
    subscribe1(housingSubscription: HousingSubscription, observe?: 'response', options?: RequestOptions<'json'>): Observable<HttpResponse<HousingSubscription>>;
    subscribe1(housingSubscription: HousingSubscription, observe?: 'events', options?: RequestOptions<'json'>): Observable<HttpEvent<HousingSubscription>>;
    subscribe1(housingSubscription: HousingSubscription, observe?: 'body' | 'events' | 'response', options?: RequestOptions<'arraybuffer' | 'blob' | 'json' | 'text'>): Observable<any> {
        const url = `${this.basePath}/housing/subscriptions`;

        let headers: HttpHeaders;
        if (options?.headers instanceof HttpHeaders) {
            headers = options.headers;
        } else {
            headers = new HttpHeaders(options?.headers);
        }
        // Set Content-Type for JSON requests if not already set
        if (!headers.has('Content-Type')) {
            headers = headers.set('Content-Type', 'application/json');
        }

        return this.httpClient.request('post', url, {
            body: housingSubscription,
            observe,
            headers,
            reportProgress: options?.reportProgress,
            withCredentials: options?.withCredentials,
            context: this.createContextWithClientId(options?.context)
        });
    }

    getByPromoter(promoterId: number, pageable: Pageable, observe?: 'body', options?: RequestOptions<'json'>): Observable<PagedModelHousingSubscription>;
    getByPromoter(promoterId: number, pageable: Pageable, observe?: 'response', options?: RequestOptions<'json'>): Observable<HttpResponse<PagedModelHousingSubscription>>;
    getByPromoter(promoterId: number, pageable: Pageable, observe?: 'events', options?: RequestOptions<'json'>): Observable<HttpEvent<PagedModelHousingSubscription>>;
    getByPromoter(promoterId: number, pageable: Pageable, observe?: 'body' | 'events' | 'response', options?: RequestOptions<'arraybuffer' | 'blob' | 'json' | 'text'>): Observable<any> {
        const url = `${this.basePath}/housing/subscriptions/promoter/${promoterId}`;

        let params = new HttpParams();
        if (pageable != null) {
            params = HttpParamsBuilder.addToHttpParams(params, pageable, 'pageable');
        }

        let headers: HttpHeaders;
        if (options?.headers instanceof HttpHeaders) {
            headers = options.headers;
        } else {
            headers = new HttpHeaders(options?.headers);
        }

        return this.httpClient.request('get', url, {
            observe,
            headers,
            params,
            reportProgress: options?.reportProgress,
            withCredentials: options?.withCredentials,
            context: this.createContextWithClientId(options?.context)
        });
    }

    findByPhone(phone: string, observe?: 'body', options?: RequestOptions<'json'>): Observable<HCustomerSubscriptionDto>;
    findByPhone(phone: string, observe?: 'response', options?: RequestOptions<'json'>): Observable<HttpResponse<HCustomerSubscriptionDto>>;
    findByPhone(phone: string, observe?: 'events', options?: RequestOptions<'json'>): Observable<HttpEvent<HCustomerSubscriptionDto>>;
    findByPhone(phone: string, observe?: 'body' | 'events' | 'response', options?: RequestOptions<'arraybuffer' | 'blob' | 'json' | 'text'>): Observable<any> {
        const url = `${this.basePath}/housing/subscriptions/customers/${phone}`;

        let headers: HttpHeaders;
        if (options?.headers instanceof HttpHeaders) {
            headers = options.headers;
        } else {
            headers = new HttpHeaders(options?.headers);
        }

        return this.httpClient.request('get', url, {
            observe,
            headers,
            reportProgress: options?.reportProgress,
            withCredentials: options?.withCredentials,
            context: this.createContextWithClientId(options?.context)
        });
    }
}
